import { Component, Input, OnInit, ElementRef } from '@angular/core';
import { GlyphService } from './gf-glyph.service';

@Component({
  selector: 'gf-glyph',
  template: ''
})
export class GlyphComponent implements OnInit {
  @Input() section: string;
  @Input('class') customClass: string;

  constructor(private glyphService: GlyphService, private elementRef: ElementRef) {}

  ngOnInit(): void {
    const section = this.section;
    if (this.glyphService.isGlyphicon(this.customClass)) {
      this.showGlyphicon(this.customClass);
    } else {
      this.showGfGlyph(this.section, this.customClass);
    }
  }

  showGlyphicon(cssClasses) {
    this.elementRef.nativeElement.innerHTML = `<i class="${ cssClasses }"></i>`;
  }

  showGfGlyph(section, cssClass) {
    const imgName = section
      ? this.glyphService.getImageNameForSection(section)
      : this.glyphService.getImageNameFromAttr(cssClass);

    if (imgName) {
      const p = this.glyphService.getImageData(imgName);
      if (! p.then) {
        this.elementRef.nativeElement.innerHTML = p;
      } else {
        p.then(
          response => {
            this.elementRef.nativeElement.innerHTML = response;
          }
        );
      }
    }
  }
}
